import axios from 'axios';
import router from '../router';
import { userClassApp } from '@/utils/getAuth';
import { showError } from '@/utils/errorsInterceptor';
import { refreshUser } from '@/api/authService';

axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;
axios.defaults.headers.common['accept'] = 'application/json';
axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;

let tokenRefreshed = false;

axios.interceptors.response.use(
  function (response) {
    // здесь может быть дополнительная обработка ответов
    return response;
  },
  async function (error) {
    if (error?.response?.status === 401) {
      const refreshTokenLS = localStorage.getItem('refresh_token');
      if (refreshTokenLS && !tokenRefreshed && refreshTokenLS !== 'undefined') {
        const refresh_token = JSON.parse(refreshTokenLS);
        tokenRefreshed = true;
        try {
          const response = await refreshUser({ refresh_token });
          if (response) {
            localStorage.setItem(
              'access_token',
              JSON.stringify(response.data.access_token)
            );
            localStorage.setItem(
              'refresh_token',
              JSON.stringify(response.data.refresh_token)
            );
            axios.defaults.headers.common['auth-token'] =
              response.data.access_token;
            //document.location.reload();
          }
        } catch (error) {
          clear();
          router.push({ name: 'HomePage' });
        }
      } else {
        clear();
        router.push({ name: 'HomePage' });
      }
    }
    return Promise.reject(error);
  }
);

const clear = () => {
  userClassApp.setUser(null);
  localStorage.removeItem('authPacker');
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('calculation_id');
};
export default axios;
